<div class="container webview text-center" [@flyInOut]="'in'">
  <div class="col-sm-12 pt-5">
    <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub1}}</h1>
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_sub2}}</h1>
  </div>
  <div class="col-sm-12 col-md-12 col-lg-3 m-auto text-left" id="commercial">
    <div class="form-group col-sm-12 m-auto px-0">
      <!-- <select (change)="getReferrals($event);" [(ngModel)]="hg_refer" class="dropdown-toggle form-control">
        <option *ngFor="let referral of referrals" value={{referral}}>{{referral}}</option>
      </select> -->
      <ng-select [items]="referrals"
        placeholder="Select"
        [searchable]="false" [clearable]="false"
        (change)="getReferrals(hg_refer);" [(ngModel)]="hg_refer"></ng-select>
    </div>
    <div class="form-group col-sm-12 m-auto px-0">
      <input type="text" class="form-control" style="font-size: 20px !important" [(ngModel)]="promo_code" placeholder="Enter promo code or referral name"
        (keydown.space)="promo_code ? null : $event.preventDefault()" (keyup)="enableButton($event)" />
    </div>
  </div>
  <div class="col-sm-12">
    <button class="btn mr-2 ml-2 disabledButton col-sm-4 mt-4 font22 text-uppercase mx-4"
      style="width:auto !important; padding-left:25px; padding-right:25px;" [ngClass]="{'combtn': disablebutton}"
      (click)="getPromoCode();">Next</button>
  </div>
</div>
<div class="container mobileview mb-5 px-0 pt-4" [attr.id]="questionObj._id" style="float:left;">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <br />
  <div class="col-10 pull-right pl-4">
    <div class="form-group col-12 px-0 mt-2 d-flex flex-wrap" style="margin-bottom:6px !important">
      <!-- <label class="col-5 col-form-label text-right">Select</label> -->
      <div class="col-sm-12 px-0" id="commercial">
        <!-- <select (change)="getReferrals($event);" [(ngModel)]="hg_refer" class="dropdown-toggle form-control">
          <option *ngFor="let referral of referrals" value={{referral}}>{{referral}}</option>
        </select> -->
        <ng-select [items]="referrals"
        placeholder="Select"
        [searchable]="false" [clearable]="false"
        (change)="getReferrals(hg_refer);" [(ngModel)]="hg_refer"></ng-select>
      </div>
    </div>
    <form #f="ngForm" (ngSubmit)="goNext();" novalidate>
      <div class="float-label-control mt-4">
        <label for="promo_code">Enter promo code or referral name</label>
        <input class="focus-none" type="text" name="promo_code" [(ngModel)]="promo_code" placeholder="Enter promo code or referral name"
          (keydown.space)="promo_code ? null : $event.preventDefault()"
          (keyup.enter)="goNext(); $event.target.blur();">
      </div>
    </form>
  </div>
</div>